import styled from 'styled-components'

export const AlbumTile = styled.div`
  height: 9.5vh;
  display: flex;
  justify-content: flex-start;
  align-items: space-between;
  flex-direction: row;
  border-radius: 19px;
  padding: 3%;
  background-image: linear-gradient(to right, #718ffc, #ea96b0);
  opacity: 0.5;
  cursor: pointer;
  width: 40%;
  overflow-y: hidden;
  margin-top: 2%;

  @media only screen and (max-width: 600px) {
    width: 95%;
  }

  &.album-tile {
    width: calc(90% - 20px);

    @media only screen and (max-width: 600px) {
      width: 90%;
    }
  }

  &.active {
    opacity: 1;
  }
`

export const PdfTIle = styled.div`
  width: 90%;
  padding: 20px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 19px;
  margin: 5px 0px;
`
